export default __webpack_public_path__ + "static/media/aws.65c8a8ff.svg";